<template>
    <div v-if="pickingData" class="rounded overflow-hidden border border-b-0">
        <table class="table w-full">
        <thead>
            <tr>
                <th class="md:table-cell text-left">Type</th>
                <th class="md:table-cell text-right">Orders</th>
                <th class="md:table-cell text-right">Items</th>
                <th class="md:table-cell text-right">Orders / Hour</th>
                <th class="md:table-cell text-right">Items / Hour</th>
            </tr>
        </thead>
        <tbody>
            <tr v-if="pickingData.length == 0">
                <td colspan="5" class="text-center">- No Data Found -</td>
            </tr>
            <tr
                v-for="pickingDataSection, pickingDataTitle in pickingData"
                :key="pickingDataTitle"
            >
                <td class="md:table-cell text-left">
                    {{ pickingDataTitle }}
                </td>
                <td v-if="pickingDataSection.ordersTotalCount > 0" class="md:table-cell text-right">
                    {{ pickingDataSection.ordersPickedCount }} / {{ pickingDataSection.ordersTotalCount }}
                </td>
                <td v-else class="md:table-cell text-right">
                    -
                </td>
                <td v-if="pickingDataSection.itemsTotalCount > 0" class="md:table-cell text-right">
                    {{ pickingDataSection.itemsPickedCount }} / {{ pickingDataSection.itemsTotalCount }}
                </td>
                <td v-else class="md:table-cell text-right">
                    -
                </td>
                <td v-if="pickingDataSection.ordersPerHour > 0" class="md:table-cell text-right">
                    {{ pickingDataSection.ordersPerHour }}
                </td>
                <td v-else class="md:table-cell text-right">
                    -
                </td>
                <td v-if="pickingDataSection.itemsPerHour > 0" class="md:table-cell text-right">
                    {{ pickingDataSection.itemsPerHour }}
                </td>
                <td v-else class="md:table-cell text-right">
                    -
                </td>
            </tr>
        </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: [
        'pickingData', 
    ],
}
</script>
